// extracted by mini-css-extract-plugin
export default {"loader":"loading-circle_loader__2+CIO","spin":"loading-circle_spin__3bLlX"};